let current = null;

export default {
 methods: {
  touchStart(e) {
     //开始触摸时 重置所有删除
    if (this !== current && !!current) {
      current.isTouchMove =false
    }
    current = this;
    this.startX = e.changedTouches[0].clientX
    this.startY = e.changedTouches[0].clientY
    this.$trigger('start',e)
  },
  touchMove(e){
    this.$trigger('move',e)
  },
  touchEnd(e) {
    var that = this
    if (e.changedTouches.length == 1) {
      let type = e.currentTarget.dataset.type //当前类型
      let index = e.currentTarget.dataset.index //当前索引
      let startX = that.startX //开始X坐标
      let startY = that.startY //开始Y坐标
      let touchMoveX = e.changedTouches[0].clientX //滑动变化坐标
      let touchMoveY = e.changedTouches[0].clientY //滑动变化坐标
      //获取滑动角度
      let angle = that.angle({
        X: startX,
        Y: startY
      }, {
        X: touchMoveX,
        Y: touchMoveY
      })
      //触摸开始与结束，手指移动的距离
      var disX = that.startX - touchMoveX
      var delBtnWidth = 40
      //如果距离小于删除按钮的1/2，不显示删除按钮
      if (Math.abs(angle) > 30||disX < delBtnWidth / 2 ) return;
      this.isTouchMove = touchMoveX>startX? false : true
    }
    this.$trigger('end',e)
  },
  angle(start, end) {
    var _X = end.X - start.X,
    _Y = end.Y - start.Y
    //返回角度 /Math.atan()返回数字的反正切值
    return 360 * Math.atan(_Y / _X) / (2 * Math.PI);
  },
 }
}